import Swiper from "swiper";
import { A11y, Navigation } from "swiper/modules";
import "@/styles/components/slider.css";
import "./card-list.css";

document.querySelectorAll(".element-cardlist").forEach((el) => {
  const container = el.querySelector(".swiper");

  new Swiper(container, {
    modules: [A11y, Navigation],
    speed: 750,
    slidesPerView: 1,
    navigation: {
      nextEl: el.querySelector(".slider-button-next"),
      prevEl: el.querySelector(".slider-button-prev"),
    },
    simulateTouch: false,
    allowTouchMove: false,
    watchSlidesProgress: true,
    centerInsufficientSlides: true,
    breakpoints: {
      740: {
        slidesPerView: 2,
      },
      960: {
        slidesPerView: 3,
      },
      1380: {
        slidesPerView: 4,
      },
      1596: {
        slidesPerView: 4,
      },
    },
  });
});
